
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingCart, User, Search, Menu, X, ChevronRight, Sparkles } from 'lucide-react';
import { useApp } from '../App';
import { auth } from '../firebase';

const Header: React.FC = () => {
  const { cart, user, categories, setIsCartOpen } = useApp();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');

  const cartCount = cart.reduce((acc, item) => acc + item.quantity, 0);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchTerm) navigate(`/search?q=${searchTerm}`);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-stone-100">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <button onClick={() => setIsMenuOpen(true)} className="md:hidden text-stone-600">
            <Menu size={24} />
          </button>

          <Link to="/" className="flex items-center space-x-2 group">
            <Sparkles className="text-amber-600 w-6 h-6" />
            <span className="text-xl md:text-2xl font-serif font-bold tracking-tight text-stone-900">Lumina<span className="text-amber-700">Home</span></span>
          </Link>

          <div className="hidden md:flex flex-1 max-w-xl mx-8">
            <form onSubmit={handleSearch} className="relative w-full">
              <input
                type="text"
                placeholder="Mum, biblo veya dekorasyon ara..."
                className="w-full bg-stone-100 border-none rounded-full py-2.5 pl-5 pr-12 focus:ring-2 focus:ring-amber-500 focus:bg-white transition-all outline-none text-sm"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button type="submit" className="absolute right-3 top-1/2 -translate-y-1/2 text-stone-400 hover:text-amber-600">
                <Search size={20} />
              </button>
            </form>
          </div>

          <div className="flex items-center space-x-2 md:space-x-4">
            <Link to={user ? "/profile" : "/auth"} className="flex items-center space-x-2 p-2 rounded-lg hover:bg-stone-50 text-stone-700">
              <User size={22} />
              <span className="hidden lg:inline text-sm font-medium">{user ? "Hesabım" : "Giriş"}</span>
            </Link>
            
            <button 
              onClick={() => setIsCartOpen(true)}
              className="relative p-2 rounded-lg hover:bg-stone-50 text-stone-700 flex items-center"
            >
              <ShoppingCart size={22} />
              {cartCount > 0 && (
                <span className="absolute top-0 right-0 bg-amber-800 text-white text-[10px] font-bold w-5 h-5 flex items-center justify-center rounded-full border-2 border-white">
                  {cartCount}
                </span>
              )}
              <span className="hidden lg:inline-block ml-2 text-sm font-medium">Sepetim</span>
            </button>
          </div>
        </div>

        <div className="hidden md:flex items-center space-x-8 h-10 overflow-x-auto scrollbar-hide justify-center">
          {categories.map((cat) => (
            <Link 
              key={cat.id} 
              to={`/category/${cat.slug}`} 
              className="text-xs text-stone-500 hover:text-amber-800 whitespace-nowrap font-bold uppercase tracking-widest pb-2 border-b-2 border-transparent hover:border-amber-800 transition-all"
            >
              {cat.name}
            </Link>
          ))}
        </div>
      </div>

      {isMenuOpen && (
        <div className="fixed inset-0 z-[100] bg-stone-900/40 backdrop-blur-sm md:hidden" onClick={() => setIsMenuOpen(false)}>
          <div className="w-[80%] max-w-sm h-full bg-white flex flex-col" onClick={e => e.stopPropagation()}>
            <div className="p-6 flex items-center justify-between border-b">
              <span className="font-serif font-bold text-xl">Menü</span>
              <button onClick={() => setIsMenuOpen(false)}><X size={24} /></button>
            </div>
            
            <div className="flex-1 overflow-y-auto p-6">
              <div className="mb-8">
                <p className="text-[10px] font-black text-stone-400 uppercase tracking-[0.2em] mb-4">Koleksiyonlar</p>
                <div className="space-y-4">
                  {categories.map((cat) => (
                    <Link 
                      key={cat.id} 
                      to={`/category/${cat.slug}`} 
                      className="flex items-center justify-between text-stone-800 font-bold"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {cat.name}
                      <ChevronRight size={18} className="text-stone-300" />
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
